import { createMuiTheme } from '@material-ui/core'
import { blue } from '@material-ui/core/colors'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import classnames from 'classnames'

export const cn = classnames
// export const CompactContext = createContext(false) // Components can listen to this to show a smaller version of themselves

export const DefaultTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#3A143E',
    },
    secondary: {
      main: blue[200],
    },
  },
})

/**
 * Creates a group of nth-of-type to simplify transition delays
 * @param total number of elements to generate rules for
 * @param increment increment delay at each nth item
 */
export const createAnimationDelay = (total: number, increment: number) => {
  return Array(total).fill(null).reduce((acc, v, i) => {
    acc[`&:nth-of-type(${i+1})`] = { animationDelay: `${i * increment}s` }
    return acc
  }, {})
}

export const animationFadeIn = {
  '@keyframes FadeIn': {
    '0%': {
      opacity: 0,
      transform: 'scale(.1)',
    },
    '85%': {
      opacity: 1,
      transform: 'scale(1.05)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
}

export const containsInvisibleInput: CSSProperties = {
  '& fieldset': {
    border: 0,
  },

  '&:hover': {
    '& fieldset': {
      border: 1,
    },
  },
}

export const hasVisibleOnHoverChild: CSSProperties = {
  '& .visible-on-hover': {
    opacity: 0,
    transition: 'opacity ease-in-out .4s',
  },

  '&:hover': {
    boxShadow: '5px solid #DDD',
    '& .visible-on-hover': {
      opacity: 1,
    },
  },
}
